import CIMSTable from 'components/CIMSTable'
import { SubTableProps } from './types'

const SubTable: React.FC<SubTableProps> = ({
  columns,
  concretePlacement,
  which,
}) => (
  /**
   * see {@link CIMSTable} docs for why i'm doing this
   */
  <div style={{ maxWidth: 644 }}>
    <CIMSTable
      disable={{ showAll: true }}
      size="small"
      columns={columns}
      records={[concretePlacement]}
      rowKey={({ globalId }) => `${which}_${globalId}`}
    />
  </div>
)

export default SubTable
